import React, { useEffect, useRef, useState } from "react";
import { UploadCloud, Trash2, Loader2 } from "lucide-react";
import { Progress } from "../components/ui/progress";
import { toast } from "sonner";
import { adminApi, uploadImage, imgUrl, errMsg } from "../lib/api";

export default function LibraryPanel() {
  const [items, setItems] = useState(null);
  const [ups, setUps] = useState([]);
  const ref = useRef(null);
  const load = async () => { try { const { data } = await adminApi.get("/admin/library"); setItems(data); } catch (e) { toast.error(errMsg(e)); setItems([]); } };
  useEffect(() => { load(); }, []);

  const handle = async (files) => {
    const list = Array.from(files || []).filter((f) => f.type.startsWith("image/"));
    if (!list.length) return;
    for (const f of list) {
      const id = `${f.name}-${Math.random()}`;
      setUps((u) => [...u, { id, name: f.name, p: 0 }]);
      try {
        const url = await uploadImage(f, (p) => setUps((u) => u.map((x) => (x.id === id ? { ...x, p } : x))));
        await adminApi.post("/admin/library", { url, caption: "" });
      } catch (e) { toast.error(`${f.name}: ${errMsg(e, "upload failed")}`); }
      setUps((u) => u.filter((x) => x.id !== id));
    }
    toast.success("Library updated");
    load();
  };

  const remove = async (id) => {
    try { await adminApi.delete(`/admin/library/${id}`); setItems((i) => i.filter((x) => x.id !== id)); toast.success("Removed from library"); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <div className="dropzone p-7 text-center cursor-pointer" onClick={() => ref.current?.click()}
        onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); handle(e.dataTransfer.files); }} data-testid="library-dropzone">
        <UploadCloud className="w-9 h-9 mx-auto text-[#ee3a70]" />
        <p className="mt-2 font-medium">Upload member-only photos</p>
        <p className="text-[13px] text-[#7a7276]">Used by AI for From Me, Updates, Polls, Surprises, For You and photos in chat. Never shown on the public page.</p>
        <input ref={ref} type="file" multiple accept="image/*" className="hidden" onChange={(e) => { handle(e.target.files); e.target.value = ""; }} data-testid="library-input" />
      </div>
      {ups.map((u) => (
        <div key={u.id} className="flex items-center gap-3 mt-3"><Loader2 className="w-4 h-4 animate-spin text-[#ee3a70]" /><span className="text-[13px] w-48 truncate">{u.name}</span><Progress value={u.p} className="h-2 flex-1" /></div>
      ))}
      <h2 className="text-[18px] font-semibold mt-8 mb-4">Member library <span className="text-[#a79fa3] font-normal">({items?.length || 0})</span></h2>
      {!items ? <Loader2 className="w-6 h-6 animate-spin mx-auto text-[#ee3a70]" /> : (
        <div className="grid grid-cols-3 md:grid-cols-6 gap-3" data-testid="library-grid">
          {items.map((i) => (
            <div key={i.id} className="relative group aspect-[3/4] rounded-xl overflow-hidden" data-testid="library-item">
              <img src={imgUrl(i.url)} alt="" className="w-full h-full object-cover" />
              <button onClick={() => remove(i.id)} className="absolute top-2 right-2 icon-btn danger opacity-0 group-hover:opacity-100 transition-opacity" data-testid="library-delete"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
